import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline"
import { Dropdown } from "antd"
import { ItemType } from "antd/es/menu/hooks/useItems"
import { FC } from "react"

type Props = {
  menuItems: ItemType[]
  /** Names the icon-only trigger for screen readers, e.g. "Actions for Sell to the World". */
  label?: string
  className?: string
}

export const TableActionButton: FC<Props> = ({
  menuItems = [],
  label,
  className,
}) => {
  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        items: menuItems,
      }}
    >
      <button
        type="button"
        aria-label={label}
        className={className}
      >
        <EllipsisHorizontalIcon
          className="w-5 text-primary500"
          fontWeight="bold"
        />
      </button>
    </Dropdown>
  )
}
